/**
 * Created by kierangrosvenor on 05/05/2017.
 */

import axios from 'axios'
import config from '../../config'

let LoginApi = {
  /**
   * @param email
   * @param password
   * @param remember_me
   * @param offerCode
   * @constructor
   */
  Authenticate(email, password, remember_me, captcha, offerCode = null) {
    return axios.post(config.apiUrl + 'login/v2/', {
      email: email,
      password: btoa(password),
      remember_me: remember_me,
      offerCode: offerCode,
      captcha: captcha,
      user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
  },
  /**
   * @param email
   * @returns {AxiosPromise}
   * @constructor
   */
  ResetPassword(email) {
    /**
     * Alt link is to control password reset flow when migrating to new version.
     */
    return axios.post(config.apiUrl + 'reset/email/', {
      email: email
    });
  },
  /**
   *
   * @param email
   * @param token
   * @constructor
   */
  updatePasswordWithToken(model) {
    return axios.post(config.apiUrl + 'reset/password/', model);
  }
};

export default LoginApi



// WEBPACK FOOTER //
// ./src/api/Login/index.js